import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetObservationStatistics = () => {
  // Fetching multiple data sets
  const obsPerSiteQuery = useAuthenticatedQuery(
    ["obspersite"],
    "/api/v1/stats/observations/count/per-site"
  );
  const obsPerWorkflowQuery = useAuthenticatedQuery(
    ["obsperworkflow"],
    "/api/v1/stats/observations/count/per-workflow"
  );
  const obsMonthlyTrendQuery = useAuthenticatedQuery(
    ["obsmonthlytrend"],
    "/api/v1/stats/observations/monthly-trend"
  );
  const obsPerAuthorQuery = useAuthenticatedQuery(
    ["obsperauthor"],
    "/api/v1/stats/observations/count/per-author"
  );
  const obsCompletionQuery = useAuthenticatedQuery(
    ["obscompletion"],
    "/api/v1/observations/completion-time"
  );
  const obsCompletionSummaryQuery = useAuthenticatedQuery(
    ["obscompletionsummary"],
    "/api/v1/observations/completion-time-summary"
  );

  // Destructuring
  const {
    data: obsPerSite,
    isLoading: obsPerSiteLoading,
    error: errorObsPerSite,
    refetch: refetchObsPerSite,
  } = obsPerSiteQuery || {};

  const {
    data: obsPerWorkflow,
    isLoading: obsPerWorkflowLoading,
    error: errorObsPerWorkflow,
    refetch: refetchObsPerWorkflow,
  } = obsPerWorkflowQuery || {};

  const {
    data: obsMonthlyTrend,
    isLoading: obsMonthlyTrendLoading,
    error: errorObsMonthlyTrend,
    refetch: refetchObsMonthlyTrend,
  } = obsMonthlyTrendQuery || {};

  const {
    data: obsPerAuthor,
    isLoading: obsPerAuthorLoading,
    error: errorObsPerAuthor,
    refetch: refetchObsPerAuthor,
  } = obsPerAuthorQuery || {};

  const {
    data: obsCompletion,
    isLoading: obsCompletionLoading,
    error: errorObsCompletion,
    refetch: refetchObsCompletion,
  } = obsCompletionQuery || {};

  const {
    data: obsCompletionSummary,
    isLoading: obsCompletionSummaryLoading,
    error: errorObsCompletionSummary,
    refetch: refetchObsCompletionSummary,
  } = obsCompletionSummaryQuery || {};

  // Single flags
  const isLoading =
    obsPerSiteLoading ||
    obsPerWorkflowLoading ||
    obsMonthlyTrendLoading ||
    obsPerAuthorLoading ||
    obsCompletionLoading ||
    obsCompletionSummaryLoading;

  const error =
    errorObsPerSite ||
    errorObsPerWorkflow ||
    errorObsMonthlyTrend ||
    errorObsPerAuthor ||
    errorObsCompletion ||
    errorObsCompletionSummary;

  // Single refetchAll
  const refetchAll = async () => {
    await Promise.all([
      refetchObsPerSite(),
      refetchObsPerWorkflow(),
      refetchObsMonthlyTrend(),
      refetchObsPerAuthor(),
      refetchObsCompletion(),
      refetchObsCompletionSummary(),
    ]);
  };

  return {
    // Counts and Totals
    counts: {
      obsPerSite,
      obsPerWorkflow,
      obsPerAuthor,
      obsCompletion,
      obsCompletionSummary,
    },

    // Trend Data
    trends: {
      obsMonthlyTrend,
    },

    // Status helpers
    isLoading,
    error,

    // Refetchers
    refetch: {
      refetchObsPerSite,
      refetchObsPerWorkflow,
      refetchObsMonthlyTrend,
      refetchObsPerAuthor,
      refetchObsCompletion,
      refetchObsCompletionSummary,
      refetchAll,
    },
  };
};

export default useGetObservationStatistics;
